enum UserRoleType {
    internal = 'internal',
    external = 'external',
}

export default UserRoleType;
